import { runMutationBatch } from "../../services"

export const waitingServices = { runMutationBatch }
